import { render, staticRenderFns } from "./lookGroup.vue?vue&type=template&id=124ebf6c&scoped=true&"
import script from "./lookGroup.vue?vue&type=script&lang=js&"
export * from "./lookGroup.vue?vue&type=script&lang=js&"
import style0 from "./lookGroup.vue?vue&type=style&index=0&id=124ebf6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ebf6c",
  null
  
)

export default component.exports